import { computed, watch, ref } from 'vue';
import { AppProvider } from '/@/components/Application';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { useMessage } from '/@/hooks/web/useMessage';
import ModalLogin from '/@/views/sys/login/ModalLogin.vue';
import { router } from '/@/router';

const modalHandle = ref<any>(null);
export const useLoginModal = (currentRoute) => {
  const userStore = useUserStoreWithOut();
  const isLogin = computed(() => !!userStore.getToken);

  function openModal() {
    const { createInfoModal } = useMessage();
    modalHandle.value = createInfoModal({
      class: 'modal-no-btns modal-no-icon !w-[560px] linear-border rounded-lg',
      title: null,
      icon: null,
      content: () => (
        <AppProvider>
          <ModalLogin currentRoute={currentRoute} />
        </AppProvider>
      ),
      maskClosable: false,
      closable: true,
      centered: true,
      bodyStyle: {
        margin: 0,
      },
      afterClose: () => {
        isLogin.value &&
          router.replace({
            path: currentRoute.path,
            query: {
              ...currentRoute.query,
              _t: Date.now(),
            },
          });
      },
    });
  }
  function closeModal() {
    modalHandle.value && modalHandle.value.destroy();
  }

  watch(
    () => isLogin.value,
    (val) => {
      val && closeModal();
    },
    {
      immediate: true,
    },
  );

  return { openModal, closeModal };
};
